import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=5a66361a&scoped=true&"
import script from "./ModalChat.vue?vue&type=script&lang=js&"
export * from "./ModalChat.vue?vue&type=script&lang=js&"
import style0 from "./ModalChat.vue?vue&type=style&index=0&id=5a66361a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66361a",
  null
  
)

export default component.exports